export const PAGINATION_SIZE_ARRAY = [5, 10, 15, 25, 50, 100, 250];

export const SKIP_SELECT_CHECKBOX_CSV_PDF = [
	'case_search',
	'fees_view_open-',
	'printingDocumentsTable',
	'selected-cases-table'
];

export const SKIP_SELECT_RADIOBUTTON_CSV_PDF = ['installmentView'];

export const TABLE_KEY_EVENT_VIEW_ALL = 'event-view-all';
